import { buildLabMotion } from '../../buildLabMotion';

/**
 * Flash 13's join, plasma ring, flight, and page staging. The blue halves
 * are the satin gradient: a light band, then the tip returns to navy.
 */
export const flash14Motion = buildLabMotion({
  HALO_EXPAND_ANIMATION: 'apertureLabFlash14Halo',
  HALO_EXPAND_DELAY_S: 0.3456,
  HALO_EXPAND_DURATION_S: 0.528,
  /** Start the rise before the ring finishes, so the ascent is not waiting on the last of the halo. */
  ASCENT_LEAD_MS: 200,
  HANDOFF_FLIGHT_MS: 760,
  FLIGHT_EASING: 'cubic-bezier(0.4, 0.05, 0.35, 1)',
  LAND_CROSSFADE_MS: 0,
  FLIGHT_MARK_BLEND_START: 1,
  cutToHero: true,
  vectorHero: true,
  stagePage: true,
  pageRevealDelayMs: 1900,
  cardRevealDelayMs: 2700,
  cardRevealMs: 900,
  wordmarkDelayMs: 1600,
  wordmarkDurationMs: 1000,
  PAGE_BRIGHTEN_MS: 700,
  INTRO_GLOW_FILTER: 'drop-shadow(0 0 48px rgba(255, 255, 255, 0.42))',
  introSize: { xs: 208, sm: 244, md: 280 },
});
